import styled from 'styled-components'

export const PopoverError = styled.span`
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  letter-spacing: -0.03em;
  color: ${({ theme }) => theme.neutral.text.weak};
  display: flex;
  align-items: center;

  & > svg {
    margin-right: ${({ theme }) => theme.spacing.km3};
  }
`
